export const HOTJAR_TAG_SORT = 'CM Sort Candidates';
export const HOTJAR_TAG_ADD_NOTE = 'CM Add_Note';
export const HOTJAR_TAG_EMAIL = 'CM Send Email';
export const HOTJAR_TAG_BULK_ACTIONS = 'CM Bulk Actions';
export const HOTJAR_TAG_RATING = 'CM Rating';
export const HOTJAR_TAG_STATUS_CHANGE = 'CM Status Change';
export const HOTJAR_TAG_PROFILE = 'CM Profile Tab Change';
export const HOTJAR_TEAM_MEMBER_ACCESS = 'CM Team Member Access';
export const HOTJAR_FILTERS_INTERACTED = 'CM Filters Interacted';
export const HOTJAR_OVER_SIXTY_APPLICATIONS = 'CM Over 60 Apps';
export const HOTJAR_CERTSY_SKILLS_VIEWED = 'CM Certsy Skills Viewed';
